import { post, get, postExFile } from "@utils/httpUtil";
export function couponSend(data, config) {
  return post(`/c/pc/coupon/send`, data, config);
}
export function couponFindById(data, config) {
  return post(`/c/pc/coupon/findById`, data, config);
}
export function couponUserGetPageInfo(data, config) {
  return post(`/c/pc/coupon/getPageInfo`, data, config);
}
export function couponIncrSend(data, config) {
  return post(`/c/pc/coupon/incrSend`, data, config);
}
export function batchUserCouponExpireById(data, config) {
  return post(`/c/pc/userCoupon/batchExpireByCondition`, data, config);
}
export function userCouponExpireById(data, config) {
  return post(`/c/pc/userCoupon/expireById`, data, config);
}
export function getUserCouponPage(data, config) {
  return post(`/c/pc/userCoupon/page`, data, config);
}
export function userCouponExport(data, config) {
  return postExFile(`/c/pc/userCoupon/export`, data, config);
}
export function userCouponFindServiceDetail(data, config) {
  return post(`/c/pc/userCoupon/findServiceDetail`, data, config);
}
export function findUserCouponStatusList(data, config) {
  return get(`/c/pc/userCoupon/findUserCouponStatusList`, data, config);
}